import { gql } from '@apollo/client';

export const GET_MY_CHAT_SESSIONS = gql`
  query GetMyChatSessions($limit: Int) {
    myChatSessions(limit: $limit) {
      id
      sessionToken
      status
      messageCount
      createdAt
      updatedAt
      scope
      document {
        id
        title
      }
      deal {
        id
        title
      }
      documentName
      title
      lastMessage
    }
  }
`;

export const GET_CHAT_SESSION_BY_TOKEN = gql`
  query GetChatSessionByToken($sessionToken: String!) {
    chatSessionByToken(sessionToken: $sessionToken) {
      id
      sessionToken
      status
      messages
      messageCount
      createdAt
      updatedAt
      expiresAt
      scope
      document {
        id
        title
      }
      deal {
        id
        title
      }
      documentName
      title
    }
  }
`;

export const GET_CHAT_SESSIONS = gql`
  query GetChatSessions($limit: Int, $offset: Int) {
    chatSessions(limit: $limit, offset: $offset) {
      id
      sessionToken
      status
      messageCount
      createdAt
      updatedAt
      document {
        id
        title
      }
      documentName
      title
      lastMessage
    }
  }
`;